import { ChangeDetectionStrategy, Component } from '@angular/core';
import { provideValueAccessor } from '@sama/ng-core';
import { AbstractWrappedFormControl } from '../../../../cross-team-shared/forms/basic-inputs/abstract-wrapped-form-control';

@Component({
  selector: 'h3-input',
  templateUrl: './input.component.html',
  providers: [provideValueAccessor(InputComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputComponent extends AbstractWrappedFormControl<string> {}
